import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

// T0 — Section repliable partagée (remplace les ExpandableSection/CategorySection dupliquées).
export const Accordion = ({ title, defaultOpen = false, right = null, children, className = '' }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={`border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      >
        <span className="flex items-center gap-2 font-medium text-gray-800 dark:text-gray-100 text-left">
          {open ? <ChevronDown className="h-4 w-4 shrink-0" /> : <ChevronRight className="h-4 w-4 shrink-0" />}
          {title}
        </span>
        {right}
      </button>
      {open && <div className="px-4 py-3 bg-white dark:bg-gray-900">{children}</div>}
    </div>
  );
};

export default Accordion;
